<template>
  <div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <div class="card" v-if="delivery">
                <div class="card-header pb-0">
                    <div class="d-flex justify-content-between">
                        <div class="d-grid gap-2 d-flex">
                            <button 
                              @click="downloadPdf"
                              type="button"
                              :class="'btn btn-xs btn-outline-primary text-xs font-weight-normal m-0 ' + (loading_pdf ? 'disabled' : '')">
                              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading_pdf"></span>
                              <i class="fa fa-download" v-if="!loading_pdf"></i> Download PDF
                            </button>
                            <button 
                              @click="download"
                              type="button"
                              :class="'btn btn-xs btn-outline-primary text-xs font-weight-normal m-0 ' + (loading ? 'disabled' : '')">
                              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                              <i class="fa fa-download" v-if="!loading"></i> Download XLSX
                            </button>
                        </div>
                        <div class="d-grid gap-2 d-flex">
                            <argon-badge color="primary" class="text-xxs align-self-center">{{ delivery.state }}</argon-badge>
                        </div>
                    </div>
                    <hr/>
                </div>
                <div class="card-body min-vh-50 pt-0">
                    <h5>#{{delivery.name}}</h5>
                    <div class="row mt-3">
                        <div class="col-sm-6">
                            <table class="text-sm" width="100%">
                                <tbody>
                                    <tr>
                                        <td class="text-secondary" width="30%">Vendor</td>
                                        <td class="font-weight-bold">{{ delivery.partner_name }}</td>
                                    </tr>
                                    <tr>
                                        <td class="text-secondary">Vendor Code</td>
                                        <td class="font-weight-bold">{{ delivery.partner_code }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-sm-6">
                            <table class="text-sm" width="100%">
                                <tbody>
                                    <tr>
                                        <td class="text-secondary" width="30%">Period</td>
                                        <td class="font-weight-bold">{{ delivery.month }} {{ delivery.year }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="table-responsive p-0 mt-3">
                        <table class="table table-bordered align-items-center mb-0">
                            <thead class="text-center">
                                <tr>
                                    <th rowspan="2" class="text-uppercase text-xxs font-weight-bolder opacity-7 w-5">#</th>
                                    <th rowspan="2" class="text-uppercase text-xxs font-weight-bolder opacity-7">Part Number</th>
                                    <th rowspan="2" class="text-uppercase text-xxs font-weight-bolder opacity-7">Part Name</th>
                                    <th :colspan="delivery.day_to_day_column.length" class="text-uppercase text-xxs font-weight-bolder opacity-7 ps-2">Day to Day</th>
                                </tr>
                                <tr>
                                    <th 
                                        v-for="day,i in delivery.day_to_day_column"
                                        :key="i"
                                        class="text-uppercase text-xxs font-weight-bolder opacity-7">{{ day }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="line,i in delivery.detail" :key="line.id">
                                    <td class="text-xs mb-0 text-center">{{ i+1 }}</td>
                                    <td>
                                        <p class="text-xs mb-0 text-start">{{ line.product_code }}</p>
                                    </td>
                                    <td>
                                        <p class="text-xs mb-0 text-start">{{ line.product_name }}</p>
                                    </td>
                                    <td
                                        v-for="day,i in line.day_to_day"
                                        :key="i">
                                        <p class="text-xs mb-0 text-start text-center">{{ day.qty }}</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import ArgonBadge from "@/components/ArgonBadge.vue";
const endpoint = require("../router/endpoint");

export default {
  name: "delivery-detail",
  components: {
    ArgonBadge
  },
  data() {
    return {
      delivery: null,
      loading: false,
      loading_pdf: false,
    };
  },
  methods: {
    getDetail() {
      this.loading = true
      this.axios
        .post(
          endpoint.DELIVERY_DETAIL,
          {
            id: this.$route.params.id,
            partner_id: localStorage.getItem('partner_id')
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            this.delivery = response.data.data;
          } else {
            this.$notify({
              type: 'warn',
              title: 'Warning',
              text: response.data.message,
            });
          }
          this.loading = false
        })
        .catch((e) => {
          this.$notify({
                type: 'error',
                title: 'Failed',
                text: e.response.data.message,
            });
          this.loading = false;
        });
    },
    download () {
      this.loading = true
      this.axios
          .post(
          endpoint.DOWNLOAD,
          {
            res_id: this.$route.params.id,
            template_report: 'bh_sanko_forecast_vendor.sanko_daily_delivery_xlsx'
          },
          {
            headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
          )
          .then((response) => {
            console.log(response)
          if (response.data.response_code === "0000") {
              const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${response.data.data.file}`;
              const downloadLink = document.createElement("a");
              const fileName = this.delivery.name + ".xlsx";
              downloadLink.href = linkSource;
              downloadLink.download = fileName;
              downloadLink.click();
          } else {
              if (response.data.response_code !== "4000"){
              this.$notify({
                  type: 'warn',
                  title: 'Warning',
                  text: response.data.message,
              });
              }
          }
          this.loading = false
          })
          .catch((e) => {
            this.loading = false;
            this.$notify({
                type: 'error',
                title: 'Something went wrong!',
                text: e.response.data.message,
                });
          });
    },
    downloadPdf () {
      this.loading_pdf = true
      this.axios
          .post(
          endpoint.DOWNLOAD,
          {
            res_id: this.$route.params.id,
            template_report: 'bh_sanko_forecast_vendor.action_report_daily_delivery'
          },
          {
            headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
          )
          .then((response) => {
            console.log(response)
          if (response.data.response_code === "0000") {
              const linkSource = `data:application/pdf;base64,${response.data.data.file}`;
              const downloadLink = document.createElement("a");
              const fileName = this.delivery.name + ".pdf";
              downloadLink.href = linkSource;
              downloadLink.download = fileName;
              downloadLink.click();
          } else {
              if (response.data.response_code !== "4000"){
              this.$notify({
                  type: 'warn',
                  title: 'Warning',
                  text: response.data.message,
              });
              }
          }
          this.loading_pdf = false
          })
          .catch((e) => {
            this.loading_pdf = false;
            this.$notify({
                type: 'error',
                title: 'Something went wrong!',
                text: e.response.data.message,
                });
          });
    }
  },
  mounted() {
    this.getDetail();
  }
};
</script>

<style>

</style>